"use strict";
exports.__esModule = true;
exports.DEFAULT_INTERVAL = exports.DEFAULT_ITEM_WIDTH = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var FullFlat_1 = tslib_1.__importDefault(require("./Modes/FullFlat"));
var FullRotation_1 = tslib_1.__importDefault(require("./Modes/FullRotation"));
var List_1 = tslib_1.__importDefault(require("./Modes/List"));
var SingleRotation_1 = tslib_1.__importDefault(require("./Modes/SingleRotation"));
exports.DEFAULT_ITEM_WIDTH = 200;
exports.DEFAULT_INTERVAL = 2000;
var BannersHeader = styled_components_1["default"].h3(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var Banners = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    var items = data.items || [];
    var width = !data.width || data.width < 1 ? exports.DEFAULT_ITEM_WIDTH : data.width;
    var interval = !data.interval || data.interval < 1000 ? exports.DEFAULT_INTERVAL : data.interval;
    var invalid = !data.mode || !items.length;
    if (invalid && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty(data.type));
    }
    if (invalid) {
        return null;
    }
    var content = null;
    switch (data.mode) {
        case 'full-flat':
        case 'full-flat-title':
            content = (react_1["default"].createElement(FullFlat_1["default"], { items: items, width: width, withTitle: data.mode === 'full-flat-title' }));
            break;
        case 'full-rotation':
            content = react_1["default"].createElement(FullRotation_1["default"], { items: items, width: width });
            break;
        case 'single-rotation':
        case 'single-rotation-title':
            content = (react_1["default"].createElement(SingleRotation_1["default"], { items: items, width: width, interval: interval, withTitle: data.mode === 'single-rotation-title' }));
            break;
        case 'single-random-rotation':
        case 'single-random-rotation-title':
            content = (react_1["default"].createElement(SingleRotation_1["default"], { items: items, width: width, interval: interval, randomOrder: true, withTitle: data.mode === 'single-random-rotation-title' }));
            break;
        case 'list':
            content = react_1["default"].createElement(List_1["default"], { items: items });
            break;
        default:
            break;
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        data.title && (react_1["default"].createElement(BannersHeader, { className: "content-widget-header-h3" }, data.title)),
        content));
};
exports["default"] = Banners;
var templateObject_1;
